<template>
  <v-dialog v-model="dialog" width="450" persistent>
    <v-card :loading="loading" v-if="usuarioAtivo">
      <v-form @submit.prevent="trocarEmpresa()">
        <v-card-title class="font-weight-light">Trocar empresa ativa</v-card-title>
        <v-card-text>
          <v-select
            :items="empresas"
            label="Empresa ativa"
            item-value="id"
            v-model="empresaSelecionada"
          >
            <template v-slot:item="{item}">
              <v-list-item-content>
                <v-list-item-subtitle>{{item.cnpj}}</v-list-item-subtitle>
                <v-list-item-title>{{item.razao_social}}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:selection="{item}">
              <v-list-item-content>
                <v-list-item-subtitle>{{item.cnpj}}</v-list-item-subtitle>
                <v-list-item-title>{{item.razao_social}}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">CANCELAR</v-btn>
          <v-btn color="accent" depressed type="submit" :loading="loading">
            <v-icon class="mdi mdi-check mr-2" />TROCAR EMPRESA
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      empresaSelecionada: null
    };
  },
  computed: {
    ...mapState({
      usuarioAtivo: state => state.usuarios.usuarioAtivo,
      empresaAtiva: state => state.usuarios.empresaAtiva,
      empresas: state => state.usuarios.usuarioAtivo.empresas
    }),
    dialog: {
      get() {
        return this.$store.state.usuarios.trocarEmpresa.dialog;
      },
      set(value) {
        this.$store.commit("usuarios/trocarEmpresaDialog", value);
      }
    }
  },
  mounted() {
    this.empresaSelecionada = this.empresaAtiva.id;
  },
  methods: {
    async trocarEmpresa() {
      try {
        await this.$store.dispatch(
          "usuarios/trocarEmpresa",
          this.empresaSelecionada
        );
      } catch (e) {
        console.log(e);
      }

      this.dialog = false;
    }
  }
};
</script>
